module.exports = __webpack_public_path__ + "img/cju_gallery5.9e6cbd1f.jpg";